export default "__VITE_ASSET__942f5e1e__"